import LegalLayout, { Section } from "@/components/LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout title="Refund & Returns" eyebrow="Honest beauty, fair policy" lastUpdated="26 Feb 2026">
      <Section heading="1. Our promise">
        We want you to love every Blisson ritual. If something isn't right, we're here to make it
        right — promptly and respectfully, in line with the Consumer Protection (E-Commerce)
        Rules, 2020.
      </Section>

      <Section heading="2. When you can request a return">
        We accept returns within <strong>7 days of delivery</strong> in the following cases:
        {"\n• Product received is damaged in transit\n• Wrong product delivered\n• Manufacturing defect or quality issue\n• Item arrived past expiry / near-expiry"}
      </Section>

      <Section heading="3. What is NOT eligible for return">
        {"• Products that have been opened, used or partially consumed (for hygiene and safety reasons)\n• Items returned more than 7 days after delivery\n• Wholesale / salon-partner bulk orders (governed by partnership agreement)\n• Products purchased on final-sale or non-returnable badges"}
      </Section>

      <Section heading="4. How to initiate a return">
        {"1. WhatsApp us at +91 7383899003 with your order ID and a clear photo / short video of the issue within 7 days of delivery.\n2. Our team will respond within 24 hours and arrange a reverse pickup where applicable.\n3. Pack the product in its original packaging.\n4. Once we receive and inspect the item, your refund is processed."}
      </Section>

      <Section heading="5. Refund timelines">
        {"• Razorpay (cards / UPI / netbanking / wallets): 5-7 business days to the original payment method\n• Manual UPI transfers: 3-5 business days to the source UPI ID\n• Cash-on-Delivery (where applicable): refunded as Blisson store credit, or to a bank account you provide"}
      </Section>

      <Section heading="6. Replacements">
        If you'd prefer a replacement instead of a refund (subject to stock), we'll dispatch the
        new item at no extra cost within 3-5 business days of receiving the returned product.
      </Section>

      <Section heading="7. Shipping charges">
        {"• If the return is due to our error (damaged, wrong product, defect): we cover return shipping in full.\n• If it's a change-of-mind return (only on eligible items): return shipping is borne by the customer."}
      </Section>

      <Section heading="8. Cancellation before dispatch">
        Orders can be cancelled free of charge before they are marked as "shipped". Once shipped,
        the return policy above applies. Wholesale slab payments are non-refundable once the slab
        is assigned.
      </Section>

      <Section heading="9. Contact">
        {"📞 +91 7383899003 (WhatsApp preferred)\n✉ theblisson@gmail.com"}
      </Section>
    </LegalLayout>
  );
}
